import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="url(#Folder-Main_svg__a)"
      fillOpacity={0.9}
      d="M1 4.053C1 3.47 1.554 3 2.238 3h3.095c.342 0 .62.236.62.526"
    />
    <path
      fill="url(#Folder-Main_svg__b)"
      d="M1.487 6.632c.046-.51.621-.905 1.316-.905h10.878c.763 0 1.367.475 1.316 1.034l-.484 5.334c-.046.509-.621.905-1.316.905H2.319c-.763 0-1.367-.475-1.316-1.034z"
      opacity={0.8}
    />
    <path
      fill="#27DFD1"
      d="M2.36 7.471c.134-.489.65-.835 1.246-.835H14.72c.822 0 1.43.644 1.246 1.32l-1.328 4.846c-.133.488-.65.834-1.245.834H2.28c-.822 0-1.43-.644-1.246-1.319z"
      opacity={0.8}
    />
    <defs>
      <linearGradient
        id="Folder-Main_svg__a"
        x1={3.68}
        x2={5.119}
        y1={13}
        y2={8.239}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={1} stopColor="#0084FF" />
      </linearGradient>
      <linearGradient
        id="Folder-Main_svg__b"
        x1={8}
        x2={8}
        y1={5.727}
        y2={13}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.8} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFolderMain;
